/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.no_next = this.hasAttribute('data-no-next');
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      // start from current page in URL (default 1)
      this.i = this.getPageFromURL() || 1;
      this.isLoading = false;
      this.observer = null;
    }

    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
      
      const loadPrevButton = document.getElementById('load-previous-button');
      if (loadPrevButton) {
        this.loadPrevButton = loadPrevButton;
        this.setupLoadPrevious();
      }
    }

    getPageFromURL() {
      try {
        const u = new URL(window.location.href);
        const p = parseInt(u.searchParams.get('page'), 10);
        return Number.isFinite(p) && p > 0 ? p : 1;
      } catch (e) {
        return 1;
      }
    }

    addUrlParam(search, key, value) {
      const newParam = key + '=' + value;
      let params = '?' + newParam;

      if (search) {
        const replaced = search.replace(new RegExp('([?&])' + key + '=[^&]*'), '$1' + newParam);
        params = replaced === search ? (search + (search.includes('?') ? '&' : '?') + newParam) : replaced;
      }
      return params;
    }

    loadMore() {
      let base = this;
      if (!this.button) return;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }

    infinite() {
      this.setupInfiniteObserver();
    }

    setupInfiniteObserver() {
      let base = this;
      if (base.observer) base.observer.disconnect();

      base.observer = new IntersectionObserver(function (entries) {
        let entry = entries[0];
        if (!base.isLoading && (entry.isIntersecting || entry.boundingClientRect.top < 0)) {
          base.observer.disconnect();
          base.loadProducts();
        }
      }, {
        rootMargin: '200px 0px 200px 0px',
        threshold: 0
      });
      base.observer.observe(base);
    }

    loadProducts() {
      let base = this;
      if (base.isLoading || base.no_next) return;

      const nextPage = base.i + 1;
      const url = document.location.pathname + base.addUrlParam(document.location.search, 'page', nextPage);

      base.isLoading = true;
      base.setAttribute('loading', true);

      fetch(url, {
        headers: {
          'Cache-Control': 'public'
        }
      })
        .then(response => response.text())
        .then((responseText) => {
          base.renderProducts(responseText, url, nextPage);
          base.renderProductCount(responseText);
          base.isLoading = false;
          base.removeAttribute('loading');

          dispatchCustomEvent('pagination:page-changed', {
            url: url,
            page: nextPage
          });
        })
        .catch(() => {
          base.isLoading = false;
          base.removeAttribute('loading');
        });
    }

    renderProductCount(html) {
      const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
      const container = document.getElementsByClassName('desktop-filter-count');
  
      if (countHtml) {
        for (var item of container) {
          item.innerHTML = countHtml.innerHTML;
          item.classList.remove('loading');
        }
      }
  
    }

    renderProducts(html, url, page) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        // no next page
        base.no_next = true;
        if (base.observer) base.observer.disconnect();
        if (base.button) base.button.classList.add('visually-hidden');
        return;
      }

      // update no_next flag from response container
      this.no_next = grid_to_replace.hasAttribute('data-no-next');

      let products = grid_to_replace.querySelectorAll('.products--column');
      let firstNewProduct = null;

      // Eğer ürün yoksa, URL'i güncelleme ve işlemi sonlandır
      if (products.length === 0) {
        base.no_next = true;
        if (base.observer) base.observer.disconnect();
        if (base.button) base.button.classList.add('visually-hidden');
        return;
      }

      for (let i = 0; i < products.length; i++) {
        products[i].dataset.pagination = page; // tag with the page we just fetched
        this.grid.appendChild(products[i]);
        if (i === 0) firstNewProduct = products[i];
        products[i].querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      }

      // SUCCESS: update current page & URL param (no refresh) - sadece ürün varsa
      this.i = page;
      try {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('page', this.i);
        // pushState so Back button steps through pages; use replaceState if you prefer a single history entry
        window.history.pushState({ page: this.i }, '', newUrl.toString());
      } catch (e) {
        // ignore URL API errors
      }

      // scroll & animate
      if (firstNewProduct && base.classList.contains('pagination-type--infinite')) {
        const scrollOffset = 100;
        const scrollToPosition = firstNewProduct.getBoundingClientRect().top + window.pageYOffset - scrollOffset;

        if (this.animations_enabled) {
          let added_columns = this.grid.querySelectorAll('[data-pagination="' + page + '"]'),
            to_animate = [];
          for (let j = 0; j < added_columns.length; j++) {
            to_animate[j] = added_columns[j].querySelector('.product-card--image-primary');
          }
          gsap.to(to_animate, {
            scale: 1,
            opacity: 1,
            stagger: 0.15,
            ease: window.theme.settings.animation_easing,
            onStart: () => {
              window.scrollTo({ top: scrollToPosition, behavior: 'instant' });
            }
          });
        } else {
          base.removeAttribute('loading');
          window.scrollTo({ top: scrollToPosition, behavior: 'instant' });
        }
      } else if (this.animations_enabled) {
        let added_columns = this.grid.querySelectorAll('[data-pagination="' + page + '"]'),
          to_animate = [];
        for (let j = 0; j < added_columns.length; j++) {
          to_animate[j] = added_columns[j].querySelector('.product-card--image-primary');
        }
        gsap.to(to_animate, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
      } else {
        base.removeAttribute('loading');
      }

      // re-arm observer for infinite scroll if more pages remain
      if (base.classList.contains('pagination-type--infinite') && !base.no_next) {
        setTimeout(() => {
          base.setupInfiniteObserver();
        }, 1000);
      }
    }

    setupLoadPrevious() {
      this.loadPrevButton.addEventListener('click', () => {
        this.loadPreviousProducts();
      });
    }

    loadPreviousProducts() {
      const currentPage = parseInt(this.loadPrevButton.dataset.currentPage, 10);
      if (currentPage <= 1 || this.isLoading) return;

      const prevPage = currentPage - 1;
      const url = document.location.pathname + this.addUrlParam(document.location.search, 'page', prevPage);

      this.isLoading = true;
      this.loadPrevButton.setAttribute('disabled', 'true');
      this.loadPrevButton.classList.add('loading');

      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          this.renderPreviousProducts(responseText, prevPage);
          this.updateURLForPrevious(prevPage);
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.loadPrevButton.removeAttribute('disabled');
          this.loadPrevButton.classList.remove('loading');
        });
    }

    renderPreviousProducts(html, page) {
      const grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
      
      if (!grid_to_replace) return;

      const products = grid_to_replace.querySelectorAll('.products--column');
      
      // Mevcut ilk ürünü referans olarak kaydet (scroll pozisyonunu korumak için)
      const currentFirstProduct = this.grid.querySelector('.products--column');
      
      // Prepend products to grid (reverse order for correct display)
      for (let i = products.length - 1; i >= 0; i--) {
        products[i].dataset.pagination = page;
        this.grid.prepend(products[i]);
        products[i].querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      }

      // Scroll pozisyonunu koru - mevcut ilk ürüne scroll yap
      if (currentFirstProduct) {
        const scrollOffset = 100;
        const scrollToPosition = currentFirstProduct.getBoundingClientRect().top + window.pageYOffset - scrollOffset - 100;
        window.scrollTo({ top: scrollToPosition, behavior: 'instant' });
      }
    }

    updateURLForPrevious(newPage) {
      try {
        const newUrl = new URL(window.location.href);
        
        if (newPage === 1) {
          // Page 1 ise parametreyi tamamen kaldır
          newUrl.searchParams.delete('page');
        } else {
          // Değilse yeni page değerini set et
          newUrl.searchParams.set('page', newPage);
        }
        
        window.history.pushState({ page: newPage }, '', newUrl.toString());
        
        // Butonu güncelle veya gizle
        if (newPage === 1) {
          const container = document.getElementById('LoadPreviousContainer');
          if (container) container.remove();
        } else {
          this.loadPrevButton.dataset.currentPage = newPage;
          this.loadPrevButton.removeAttribute('disabled');
          this.loadPrevButton.classList.remove('loading');
        }
      } catch (e) {
        console.error('URL update failed:', e);
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
